type LazyLoadScriptOptions = {
	src: string;
	onLoad?: () => void;
	onError?: () => void;
	setAsync?: boolean;
	setDefer?: boolean;
};

const lazyLoadCache = (window.Stash.lazyLoad = {
	fetched: {} as Record<string, boolean>,
	success: {} as Record<string, boolean>,
	error: {} as Record<string, boolean>,
});

export const lazyLoadScript = (options: LazyLoadScriptOptions): void => {
	const { src, onLoad, onError, setAsync, setDefer } = options;

	if (lazyLoadCache.success[src]) {
		return onLoad && onLoad();
	}

	if (lazyLoadCache.error[src]) {
		return onError && onError();
	}

	if (lazyLoadCache.fetched[src]) {
		return; // don't load scripts more than once.
	}

	lazyLoadCache.fetched[src] = true;

	const script = document.createElement('script');
	script.src = src;

	if (setAsync) script.async = true;
	if (setDefer) script.defer = true;

	script.onload = () => {
		lazyLoadCache.success[src] = true;
		onLoad && onLoad();
	};

	script.onerror = () => {
		lazyLoadCache.error[src] = true;
		onError && onError();
	};

	document.body.appendChild(script);
};

export default lazyLoadScript;
